import { getCookie } from 'cookies-next';

import {
  CURRENT_ACTIVE_AB_EXPERIMENTS,
  getVariantCookieKey,
} from 'lib/experiment';

import { log as logger } from '../utils';

const isDebuggerActive = !process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID;

const log = (...args) => logger('ga', ...args);

const getExperimentMeta = () => {
  let experimentMeta = null;

  if (CURRENT_ACTIVE_AB_EXPERIMENTS.length > 0) {
    CURRENT_ACTIVE_AB_EXPERIMENTS.forEach(({ id }) => {
      const variant = getCookie(getVariantCookieKey(id));

      if (variant) {
        experimentMeta = experimentMeta
          ? `${experimentMeta},${id}:${variant}`
          : `${id}:${variant}`;
      }
    });
  }

  return experimentMeta;
};

export const sendEvent = ({ action, category, label, value, ...rest }) => {
  const staticOptions = {
    // Identifier for the Promobit 2.0
    version: 2,
    // Using a non-interaction event for all cases is wrong, but was asked by
    // the product team. It might be fixed in the future as all non-interaction
    // are documented
    non_interaction: true,
    ...rest,
  };

  if (isDebuggerActive) {
    log('Event sent with the following payload:\n', {
      action,
      category,
      label,
      value,
      ...staticOptions,
    });
    return;
  }

  // Docs: https://developers.google.com/analytics/devguides/collection/ga4/events?client_type=gtag
  const eventMeta = {
    ...staticOptions,
    event_category: category,
    value,
  };

  if (label) {
    eventMeta.event_label = label;
  }

  const experimentMeta = getExperimentMeta();

  if (experimentMeta) {
    eventMeta.experiment_meta = experimentMeta;
  }

  window?.gtag('event', action, eventMeta);
};

export const sendUserIdToGoogleAnalytics = (userId) => {
  if (isDebuggerActive) {
    log('Send user id to Google Analytics:\n', {
      user_id: userId,
    });
    return;
  }

  window?.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID, {
    user_id: userId,
  });
  window?.gtag('set', { user_id: userId });
};
